// extracted by mini-css-extract-plugin
export var appStore = "styles-module__appStore___h6wqU";
export var badgeImage = "styles-module__badgeImage___Sp1Jh";
export var badgeStarContainer = "styles-module__badgeStarContainer___lUDuZ";
export var container = "styles-module__container___TLxbc";
export var hoverAnimation = "styles-module__hoverAnimation___Tk3wR";
export var innerContainer = "styles-module__innerContainer___wJAXp";
export var rating = "styles-module__rating___fFw5G";
export var starsImage = "styles-module__starsImage___elslI";
export var stores = "styles-module__stores___xd56v";
export var titleBottom = "styles-module__titleBottom___HIn9e";
export var titleTop = "styles-module__titleTop___ktEnw";